"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Store = function Store(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 34.988V87a2 2 0 0 0 2 2h78a2 2 0 0 0 2-2V34.988a2 2 0 0 0-.94-1.696l-39-24.375a2 2 0 0 0-2.12 0l-39 24.375A2 2 0 0 0 7 34.988zM.94 29.412l46-28.75a2 2 0 0 1 2.12 0l46 28.75a2 2 0 0 1 .94 1.696V94a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V31.108a2 2 0 0 1 .94-1.696zM19 53h58a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 0h3a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V55a2 2 0 0 1 2-2zm55 0h3a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V55a2 2 0 0 1 2-2zm-33 0h3a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V55a2 2 0 0 1 2-2zm-8 17h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm4-37h23a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H37a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Store;